
import React, { JSX } from 'react'

export const TWITCH_BRAND_ICON_SRC = '/images/glitch_flat_purple.png'
export const YOUTUBE_BRAND_ICON_SRC = '/images/yt_icon_red_digital.png'

const BOX_CLASS: Record<'md' | 'sm', string> = {
  md: 'flex size-10 shrink-0 items-center justify-center rounded-lg bg-white/5 p-1.5',
  sm: 'flex size-5 shrink-0 items-center justify-center rounded bg-white/5 p-0.5'
}

export const ProviderBrandIcon = ({
  src,
  size = 'md'
}: {
  src: string
  size?: 'md' | 'sm'
}): JSX.Element => (
  <span className={BOX_CLASS[size]}>
    <img src={src} alt='' className='max-h-full max-w-full object-contain' />
  </span>
)
